export function formatApiErrorDetail(detail) {
  if (detail == null) return 'Une erreur est survenue. Réessayez.';
  if (typeof detail === 'string') {
    // Friendlier French translations for common auth errors
    const map = {
      'Not authenticated': 'Tu dois être connecté. Reconnecte-toi pour continuer.',
      'Token expired': 'Ta session a expiré. Reconnecte-toi.',
      'Invalid token': 'Session invalide. Reconnecte-toi.',
      'Invalid token type': 'Session invalide. Reconnecte-toi.',
      'User not found': 'Compte introuvable.',
      'Invalid email or password': 'Email ou mot de passe incorrect.',
      'Email already registered': 'Cet email est déjà utilisé.',
    };
    return map[detail] || detail;
  }
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}
